import { css } from 'styled-components';
export default {
    inter: {
        light: css `
      font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont;
      font-style: normal;
      font-weight: 300;
    `,
        regular: css `
      font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont;
      font-style: normal;
      font-weight: 400;
    `,
        medium: css `
      font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont;
      font-style: normal;
      font-weight: 500;
    `,
        semiBold: css `
      font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont;
      font-style: normal;
      font-weight: 600;
    `,
        bold: css `
      font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont;
      font-style: normal;
      font-weight: 700;
    `,
        extraBold: css `
      font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont;
      font-style: normal;
      font-weight: 800;
    `,
    },
    sofiaPro: {
        light: css `
      font-family: 'sofia-pro', system-ui, -apple-system, BlinkMacSystemFont;
      font-style: normal;
      font-weight: 300;
    `,
        regular: css `
      font-family: 'sofia-pro', system-ui, -apple-system, BlinkMacSystemFont;
      font-style: normal;
      font-weight: 400;
    `,
        medium: css `
      font-family: 'sofia-pro', system-ui, -apple-system, BlinkMacSystemFont;
      font-style: normal;
      font-weight: 500;
    `,
        semiBold: css `
      font-family: 'sofia-pro', system-ui, -apple-system, BlinkMacSystemFont;
      font-style: normal;
      font-weight: 600;
    `,
        bold: css `
      font-family: 'sofia-pro', system-ui, -apple-system, BlinkMacSystemFont;
      font-style: normal;
      font-weight: 700;
    `,
        black: css `
      font-family: 'sofia-pro', system-ui, -apple-system, BlinkMacSystemFont;
      font-style: normal;
      font-weight: 900;
    `,
    },
};
